import { FiBook, FiCalendar, FiClock, FiMapPin, FiUser } from 'react-icons/fi';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { TbDoor } from 'react-icons/tb';

const slotHeaderPartSx = {
	alignItems: 'center',
	gap: 1,
	minW: 0,
	whiteSpace: 'nowrap' as const,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
};

function SlotHeaderInfo({ slot }: { slot: any }) {
	const showRoom = slot?.location !== 'online' && Boolean(slot?.room);
	const slotLocation = slot?.location;

	return (
		<Flex
			alignItems="center"
			gap={3}
			flex="1"
			minW={0}
			overflow="hidden"
			whiteSpace="nowrap"
		>
			<Flex {...slotHeaderPartSx} gap={1.5} flex="0 0 130px">
				<Icon as={FiBook} color="gray.400" />
				<Text truncate>{slot?.code}</Text>
			</Flex>
			<Flex {...slotHeaderPartSx} gap={1.5} flex="0 0 160px">
				<Icon as={FiUser} color="gray.400" />
				<Text truncate>{slot?.defaultTeacher}</Text>
			</Flex>
			<Flex {...slotHeaderPartSx} gap={1.5} flex="0 0 100px">
				<Icon as={FiCalendar} color="gray.400" />
				<Text truncate>{slot?.day} {slot?.time}</Text>
			</Flex>
			<Flex {...slotHeaderPartSx} gap={1.5} flex="0 0 80px">
				<Icon as={FiClock} color="gray.400" />
				<Text truncate>{slot?.duration}min</Text>
			</Flex>
			<Flex alignItems="center" minW={0} flex="1" gap={3}>
				<Flex alignItems="center" gap={1.5} flex="0 0 auto" whiteSpace="nowrap">
					<Icon as={FiMapPin} color="gray.400" />
					<Text>{slotLocation}</Text>
				</Flex>
				{showRoom && (
					<Flex {...slotHeaderPartSx} gap={1.5} flex="0 0 80px">
						<Icon as={TbDoor} color="gray.400" />
						<Text truncate>{slot?.room}</Text>
					</Flex>
				)}
			</Flex>
		</Flex>
	);
}

export default SlotHeaderInfo;